import React from 'react';
import { aboutContent } from '@/content/about';
import { Reveal, Section } from '@/components/ui';

const AboutUs: React.FC = () => {
    return (
        <Section id="about" className="about-us" title={aboutContent.title}>
            <Reveal as="div" className="about-content">
                <p>
                    {aboutContent.lead.before}<strong>{aboutContent.lead.legalName}</strong>{aboutContent.lead.after}
                </p>
                {aboutContent.paragraphs.map((paragraph, index) => (
                    <p key={index}>{paragraph}</p>
                ))}
            </Reveal>
        </Section>
    );
};

export default AboutUs;
